import * as propertyTypes from "../property_types.js"

export interface Datasource {
    getDataSourceIdentifier(): string;
    getDatasourceServiceId(): string;
};

const extractServiceId = (dataUrl): string => {
    var index = dataUrl.substring(15, dataUrl.length);
    index = index.substring(0, index.indexOf('/'));
    return index;
}

export class UrlDataSource extends propertyTypes.Serializable implements Datasource {

    private dataUrlMetadata = new propertyTypes.ServiceSelectorProperty("dataUrl", "Data url", false, propertyTypes.DataSourceType.sql);
    public dataUrl: string;

    private allMetaData = [this.dataUrlMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetaData;
    };

    getDataSourceIdentifier(): string {
        return this.dataUrl;
    }

    getDatasourceServiceId(): string {
        if (this.dataUrl) {
            return extractServiceId(this.dataUrl);
        }
        return null;
    }
}

export class HierarchicalDataSource extends propertyTypes.Serializable implements Datasource {
    private dataUrlMetadata = new propertyTypes.ServiceSelectorProperty("dataUrl", "Data url", false, propertyTypes.DataSourceType.hierarchicalSql);
    public dataUrl: string;

    private queryNameMetadata = new propertyTypes.TextProperty("queryName", "Query name");
    public queryName: string;

    private allMetaData = [this.dataUrlMetadata, this.queryNameMetadata];

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetaData;
    };

    getDataSourceIdentifier(): string {
        if (!this.dataUrl || !this.queryName) {
            return null;
        }
        return this.dataUrl + "#" + this.queryName;
    }

    getDatasourceServiceId(): string {
        if (this.dataUrl) {
            return extractServiceId(this.dataUrl);
        }
        return null;
    }
}

export const dataSourceMetadata = new propertyTypes.ObjectPropertyExt("dataSource", "Data source")
    .addStateImplementation("sql", UrlDataSource)
    .addStateImplementation("hierarchical sql", HierarchicalDataSource);